import { render } from "./Index.vue?vue&type=template&id=ed1c5b1c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=ed1c5b1c&lang=scss&scoped=true"
import "./Index.vue?vue&type=style&index=1&id=ed1c5b1c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ed1c5b1c"

export default script